"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validFunction = validFunction;
exports.validFunctionOld = validFunctionOld;
const defineSchema_1 = require("./defineSchema");
const fix_parent_1 = require("./fix$parent");
const funcParams_1 = require("./funcParams");
const schemaPath_1 = require("./schemaPath");
const cacheFuncs = {};
function validFunction(schema, validFunc, cache = true, debug
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
) {
    let func = null;
    if (validFunc) {
        if ((0, defineSchema_1.isFunction)(validFunc)) {
            func = validFunc;
        }
        else {
            let stext = '';
            if (Array.isArray(validFunc)) {
                stext = validFunc.join('\r\n');
            }
            else {
                stext = validFunc;
            }
            if (cache && !debug) {
                func = cacheFuncs['valid_' + stext];
                if (func !== undefined) {
                    return func;
                }
            }
            stext = `${(0, fix_parent_1.fix$parent)(stext)}`;
            // let ftext = '';
            // stext = fix$parent(stext);
            let ffunc = '';
            if (stext.indexOf('$value') > -1) {
                ffunc += `var $value=$obj.$model;\r\n`;
            }
            if (debug) {
                ffunc += `/*** function body ***/\r\n`;
            }
            // ffunc+=`${}`;
            // ffunc += 'with($data) {';
            // ffunc += `with(parent) ${stext};`;
            // ffunc += '};';
            // ffunc += `console.log('validFuncResult','${propName}',$result);`;
            // nie ma potrzeby, return i tak zadziała wcześniej
            /*
                if (stext.indexOf('return ') === -1) {
                    ffunc += '\r\nreturn $result;';
                }
                */
            // const r = /(return[\s\"\!\'\(\;]|return$)/;
            if (stext.indexOf('$result') > -1) {
                ffunc += `var $result=null;\r\n${stext}\r\nreturn $result;`;
                //} else if (stext.indexOf('return ') == -1) {
                // eslint-disable-next-line no-useless-escape
            }
            else if (!/(return[\s\"\!\'\(\;]|return$)/.test(stext))
                ffunc += `return (${stext})`;
            else {
                ffunc += stext;
            }
            if (debug) {
                ffunc = `\r\n/*** ${(0, schemaPath_1.schemaPath)(schema, true)} validFunc ***/\r\nvar $objpath = $obj.$path; // model path\r\ndebugger;\r\n\r\n${ffunc}`;
                // ffunc = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ffunc;
            }
            // old
            /*
                ftext += `return (${stext});`;
          
          
          
                if (debug && !debug) {
                    ftext = 'debugger;\r\n' + ftext;
                }
                */
            func = new Function('{' + funcParams_1.funcParams + '}', ffunc);
            if (cache) {
                cacheFuncs['valid_' + stext] = func;
            }
        }
    }
    return func;
}
function validFunctionOld(schema, validFunc, cache = true, debug) {
    let func = null;
    if (validFunc) {
        let stext = '';
        if (Array.isArray(validFunc)) {
            stext = validFunc.join('\r\n');
        }
        else {
            stext = validFunc;
            if (stext.indexOf('{') === -1) {
                stext = `$result=(${stext});`;
            }
        }
        if (cache && !debug) {
            func = cacheFuncs['valid_' + stext];
            if (func !== undefined) {
                return func;
            }
        }
        // let ftext = '';
        // stext = fix$parent(stext);
        let ffunc = `var $value=$obj.$model;\r\nvar $result=null;\r\n`;
        if (debug) {
            func += `/*** function body ***/\r\n`;
        }
        ffunc += `${(0, fix_parent_1.fix$parent)(stext)}`;
        // ffunc+=`${}`;
        // ffunc += 'with($data) {';
        // ffunc += `with(parent) ${stext};`;
        // ffunc += '};';
        // ffunc += `console.log('validFuncResult','${propName}',$result);`;
        // nie ma potrzeby, return i tak zadziała wcześniej
        /*
            if (stext.indexOf('return ') === -1) {
                ffunc += '\r\nreturn $result;';
            }
            */
        ffunc += '\r\nreturn $result;';
        if (debug) {
            ffunc = `\r\n/*** ${(0, schemaPath_1.schemaPath)(schema, true)} validFunc ***/\r\nvar $objpath = $obj.$path; // model path\r\ndebugger;\r\n\r\n${ffunc}`;
            // ffunc = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ffunc;
        }
        // old
        /*
            ftext += `return (${stext});`;
    
    
    
            if (debug && !debug) {
                ftext = 'debugger;\r\n' + ftext;
            }
            */
        func = new Function(funcParams_1.funcParams, ffunc);
        if (cache) {
            cacheFuncs['valid_' + stext] = func;
        }
    }
    return func;
}
exports.default = validFunction;
//# sourceMappingURL=validFunction.js.map